import { Pipe, PipeTransform } from '@angular/core';
import { BreezeEntity } from '@common/classes/breeze-entity';

@Pipe({
    name: 'active',
    pure: false
})
export class ActivePipe implements PipeTransform {
    transform(value: BreezeEntity[], ...args: unknown[]): unknown {
        const filtered = value?.filter(x => x.active === undefined || x.active === true);

        return value?.length === filtered?.length ? value : filtered;
    }
}
